import commafy from './commafy';

export default number => `$${commafy(number.toFixed(2))}`;
